// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"487":"ac6049c3","990":"8c8be460"}[chunkId] + ".chunk.css";
};